import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import PhilosophyFounders from "./sections/PhilosophyFounders";
import Philosophy from "./sections/Philosophy";
import OurExpertiseServices from "./sections/OurExpertiseServices";
import WhyChooseUs from "./sections/WhyChooseUs";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
import FoundersExperience from "./sections/FoundersExperience";
import LocalPresence from "./sections/LocalPresence";
export default function AboutUsPage() {
  return <div>
      <Header />
      <HeroIntroduction />
      <PhilosophyFounders />
      <Philosophy />
      <FoundersExperience />   
      <WhyChooseUs />
      <OurExpertiseServices />      
      <LocalPresence />
      <CallToAction />
      <Footer />
    </div>;
}